<template>
  <el-dropdown @command="handleCommand" @visible-change="handleVisibleChange">
    <span class="avatar-dropdown">
      <!-- <el-avatar class="user-avatar" :src="avatar" /> -->
      <div class="user-name">
        <!-- <span class="hidden-xs-only">{{ username }}</span> -->
        <img src="@/assets/images/head_icon.png" class="head_icon" />
        <!-- <vab-icon
          class="vab-dropdown"
          :class="{ 'vab-dropdown-active': active }"
          icon="arrow-down-s-line"
        /> -->
      </div>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="personalCenter">
          {{ translateTitle('マイアカウント') }}
          <svg-icon
            icon-class="external_link_line2"
            class="external"
          ></svg-icon>
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          {{ translateTitle('ログアウト') }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
  import { translateTitle } from '@/utils/i18n'
  import { mapActions, mapGetters } from 'vuex'
  // import { toLoginRoute } from '@/utils/routes'
  import { accountUrl } from '@/config/setting.config'
  export default {
    name: 'VabAvatar',
    data() {
      return {
        active: false,
      }
    },
    computed: {
      ...mapGetters({
        avatar: 'user/avatar',
        username: 'user/username',
      }),
    },
    methods: {
      translateTitle,
      ...mapActions({
        _logout: 'user/logout',
      }),
      handleCommand(command) {
        switch (command) {
          case 'logout':
            this.logout()
            break
          case 'personalCenter':
            this.personalCenter()
            break
        }
      },
      handleVisibleChange(val) {
        this.active = val
      },
      personalCenter() {
        if (accountUrl) {
          window.open(accountUrl, '_blank')
        }
      },
      async logout() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          await this._logout()
          this.$router.push({ path: '/logout', replace: true })
        } finally {
          loadingInstance.close()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar-dropdown {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;

    .user-avatar {
      width: 40px;
      height: 40px;
      margin-left: 15px;
      cursor: pointer;
      border-radius: 50%;
    }

    .user-name {
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      height: 40px;
      margin-left: 6px;
      line-height: 40px;
      cursor: pointer;

      [class*='ri-'] {
        margin-left: 0 !important;
      }
    }
  }
  .external {
    font-size: 18px;
  }
</style>
